module.exports = __webpack_public_path__ + "static/media/contact-cover.d096f597.svg";